<template>
  <div class="content">
    <div class="center">
      <div class="con_left">
        <p>
          <router-link
            :to="{ name: '二级页', query: { id: 0 } }"
            target="_blank"
            >新闻动态</router-link
          >
        </p>
        <!-- <video style="width:567px;height:auto;borderRadius: 10px;" src="../assets/video/秦书记.mp4"  controls="controls"></video> -->

        <el-carousel
          trigger="hover"
          width="580"
          height="444px"
          style="overflow: hidden; borderradius: 10px"
        >
          <!--  -->
          <el-carousel-item
            v-for="(item, index) in lunbo"
            :key="index"
            :label="index + 1"
          >
            <img
              style="
                width: 580px;
                height: 444px;
                overflow: hidden;
                cursor: pointer;
              "
              :src="'http://106.12.212.251:8094' + item.img"
              @click="toContent(item)"
            />
            <h3  class="new_title">{{ item.title }}</h3>
          </el-carousel-item>
        </el-carousel>
      </div>

      <div class="con_right">
        <ul class="choice_ul">
          <li class="choice_li" @mousemove="changeBJ(0)">
            <router-link
              :to="{ name: '二级页', query: { id: 1 } }"
              :class="idx == 0 ? 'bj' : ''"
              target="_blank"
              >工作动态</router-link
            >
          </li>
          <li class="choice_li" @mousemove="changeBJ(1)">
            <router-link
              :to="{ name: '二级页', query: { id: 2 } }"
              :class="idx == 1 ? 'bj' : ''"
              target="_blank"
              >政策文件</router-link
            >
          </li>
        </ul>
        <div class="choice_div" v-if="idx == 0">
          <ul class="right_ul">
            <li class="right_li" v-for="(item, index) in gzdtList" :key="index">
              <router-link :to="{ name: '新闻详情',query:{id:item.id} }" target="_blank"
                ><div class="dian"></div
                ><p class="title"
                  >{{item.title}}</p
                ><span class="time">{{item.logintime.substr(0,10)}}</span></router-link
              >
            </li>
          </ul>
        </div>
        <div class="choice_div" v-if="idx == 1">
          <ul class="right_ul">
            <li class="right_li" v-for="(item, index) in zcwjList" :key="index">
              <router-link :to="{ name: '新闻详情',query:{id:item.id} }" target="_blank"
                ><div class="dian"></div
                ><p class="title"
                  >{{item.title}}</p
                ><span class="time">{{item.logintime.substr(0,10)}}</span></router-link
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      idx: 0,
      // 轮播图信息
      lunbo: [],
      // 工作动态
      gzdtList:[],
      // 政策文件
      zcwjList:[]
    };
  },
  created() {},
  mounted() {
    var _this = this;
    // console.log(this.ajax_news());
    // 轮播信息
    this.axios1("http://106.12.212.251:8094/index.php/api/index/lunbo1", {
      //这里是发送给后台的数据
      timestamp: this.timestamp,
      random: this.numRandom,
      sign: this.mainSign,
    }).then((res) => {
      // console.log('轮播新闻');

      //  console.log(res);  //获得state里的数据，把数据赋值给data里的变量
      if (res.data.length > 4) {
        _this.lunbo = res.data.slice(0, 4);
      } else {
        _this.lunbo = res.data;
      }
    });

    // 工作动态
    this.axios1("http://106.12.212.251:8094/index.php/api/index/getgongzuodongtai", {
      //这里是发送给后台的数据
      timestamp: this.timestamp,
      random: this.numRandom,
      sign: this.mainSign,
      dm:410902
    }).then((res) => {
      // console.log('工作动态');
      //  console.log(res);  //获得state里的数据，把数据赋值给data里的变量
      if (res.data.length > 9) {
        _this.gzdtList = res.data.slice(0, 9);
      } else {
        _this.gzdtList = res.data;
      }
    });
    // 工作动态
    this.axios1("http://106.12.212.251:8094/index.php/api/index/getzhengcewenjian", {
      //这里是发送给后台的数据
      timestamp: this.timestamp,
      random: this.numRandom,
      sign: this.mainSign,
      dm:410902
    }).then((res) => {
      // console.log('政策文件');
      //  console.log(res);  //获得state里的数据，把数据赋值给data里的变量
      if (res.data.length > 9) {
        _this.zcwjList = res.data.slice(0, 9);
      } else {
        _this.zcwjList = res.data;
      }
    });
  },
  computed: {},
  watch: {},
  methods: {
    toContent(data) {
      // this.$router.push({name:'新闻详情',query: {id:data.id}}
      // )

      let routeUrl =this.$router.resolve({name:'新闻详情',query: {id:data.id}}
      )
window.open(routeUrl.href, '_blank');
    },
    changeBJ(e) {
      this.idx = e;
    },
    
  },
};
</script>

<style scoped>
.content {
  width: 100%;
  height: auto;
  padding-bottom: 30px;
}
.center {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  width: 1200px;
  height: auto;
  margin: 0 auto;
}
.choice_ul {
  display: block;
  width: 567px;
  height: 46px;
  padding: 40px 0 15px 0;
}
.choice_li {
  display: block;
  list-style: inside none;
  float: left;
  width: auto;
  height: 35px;
  font-size: 26px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  line-height: 35px;

  margin-right: 55px;
  cursor: pointer;
}
.choice_li a {
  color: #666666;
}
.choice_li .bj {
  color: #77a5df;
}
.choice_div {
  padding: 25px 30px 23px 30px;
  width: 520px;
  height: 396px;
  background: #ffffff;
  box-shadow: 0px 0px 21px rgba(21, 21, 21, 0.12);
  opacity: 1;
  border-radius: 10px;
}
.right_ul {
  display: block;
  width: 520px;
  height: 396px;
  overflow: hidden;
}
.right_li {
  display: block;
  margin-bottom: 20px;
  width: 520px;
  height: 24px;
  overflow: hidden;
  /* background-color: turquoise; */
}
.right_li a{
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-content: center;
  align-items: center;
  width: 520px;
  height: 24px;
  overflow: hidden;
  /* background-color: turquoise; */
}
.dian {
  display: block;
  width: 8px;
  height: 8px;
  background: #77a5df;
  border-radius: 50%;
}
.title {
  padding: 0  8px 0 0;
  width: 368px;
  height: 24px;
  font-size: 18px;
  font-family: MicrosoftYaHei;
  line-height: 24px;
  color: #333333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.time {
  width: 120px;
  height: 24px;
  font-size: 18px;
  font-family: MicrosoftYaHei;
  line-height: 24px;
  color: #999999;
}

.con_left {
  display: block;
  width: 580px;
  height: auto;
  padding-top: 40px;
}
.con_left p {
  display: block;
  padding-bottom: 20px;
  width: auto;
  height: 35px;
  font-size: 26px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  line-height: 35px;
  color: #77a5df;
  cursor: pointer;
}
.con_left p a {
  color: #77a5df;
}

/* 轮播样式 */
.el-carousel /deep/ .el-carousel__indicators--horizontal {
  width: auto;
  padding: 10px 24px 10px 0;
  height: 30px;
  /* background: #00000080; */
  display: flex;
  justify-content: flex-end;
}
/* .el-carousel /deep/ .el-carousel__indicators--horizontal li{
  float: right;
} */
.el-carousel /deep/ .new_title {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 380px;
  padding: 10px 200px 10px 24px;
  height: 30px;
  background: #00000080;
  font-size: 16px;
  font-family: SourceHanSansCN-Regular;
  line-height: 30px;
  color: #ffffff !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  z-index: 9999999;
}
.el-carousel /deep/ .el-carousel__button {
  width: 17px;
  height: 17px;
  padding: 0;
  font-size: 10px;
  font-family: SourceHanSansCN-Regular;
  line-height: 17px;
  text-align: center;
  color: #333333;
}
</style>
